import { render, staticRenderFns } from "./SetAddress.vue?vue&type=template&id=405b39ee"
import script from "./SetAddress.vue?vue&type=script&lang=js"
export * from "./SetAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports